const userAgent: string = navigator.userAgent.toLocaleLowerCase();

export const app: boolean = /pcon\./.test(userAgent);
export const android: boolean = /android/.test(userAgent);
export const ios: boolean = /ipad|iphone|ipod/.test(userAgent) && !(window as {MSStream?: object}).MSStream;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/utils/UserAgent.ts